import React, { Component } from 'react';
import {Switch, Route, BrowserRouter} from 'react-router-dom';
import LoadingBar from 'react-redux-loading';
// import { ProtectedRoute } from './components/protectedRoutes/ProtectedRoutes';
import './App.css';
import Home from './components/Home';
import Terms from './components/policies/terms';
import Policy from './components/policies/privacypolicy'
import Team from './components/team';
import About from './components/About';

import UseZimble from './components/usezimble/UseZimble';
import Platform from './components/platform/Platform';
import RedirectToQuestions from './RedirectToQuestions';


class App extends Component{
  render(){
    return(
    <BrowserRouter >
      <LoadingBar/>
      <Switch>
        <Route exact path={`/`} component={Home}/> 
        <Route exact path={`/usezimble`} component={UseZimble}/> 
        <Route exact path={`/terms`} component={Terms}/> 
        <Route exact path={`/team`} component={Team}/> 
        <Route exact path={`/about`} component={About}/> 
        <Route exact path={`/policy`} component={Policy}/> 
        <Route exact path={`/platform`} component={RedirectToQuestions}/> 
        <Route path={`/platform/:type`} component={Platform}/>
      </Switch>
    </BrowserRouter>
    )
  }
}

export default App;
